import isInteger from 'lodash/isInteger';

export function formatMoney(number, keepDecimals = false, digits = 2) {
	number = number && Number(number) || 0;
	if (!isInteger(number)) {
		number = number.toFixed(keepDecimals ? digits : 0);
	}
	return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
export function formatMoneyNBSP(number, keepDecimals = false) {
	number = number && Number(number) || 0;
	if (!isInteger(number)) {
		number = number.toFixed(keepDecimals ? 2 : 0);
	}
	return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1&nbsp');
}



// WEBPACK FOOTER //
// ./frontend/shared/js/format.js